import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../libs/api';
import { getFormDataFiles, thunkErrorHandler } from '../utils';
import { TIITSignResponse, TIITSignRequest, TSaveIITSignsRequest } from './types';

export const startIITSigning = createAsyncThunk<TIITSignResponse, TIITSignRequest>(
  'iit/startIITSigning',
  async ({ path }, { rejectWithValue }) => {
    try {
      const { data } = await api.post(path, null);

      return { documentsToSign: data.documentsToSign };
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const saveSignsFromIIT = createAsyncThunk<TIITSignResponse, TSaveIITSignsRequest>(
  'iit/saveSignsFromIIT',
  async ({ path, fileList }, { rejectWithValue }) => {
    try {
      const formData = getFormDataFiles(fileList);
      const { data } = await api.post(path, formData);

      return {
        documentsToSign: data.documentsToSign,
        unSavedDocuments: data.unSavedDocuments,
        uploadedDocuments: data.uploadedDocuments,
      };
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const startIITSigningController = createAsyncThunk<TIITSignResponse, TIITSignRequest>(
  'iit/startIITSigningController',
  async ({ path }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(path);

      return { documentsToSign: data.documentsToSign };
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const saveSigningControllerFromIIT = createAsyncThunk<
  TIITSignResponse,
  TSaveIITSignsRequest
>('iit/saveSigningControllerFromIIT', async ({ path, fileList }, { rejectWithValue }) => {
  try {
    const formData = getFormDataFiles(fileList);
    const { data } = await api.post(path, formData);

    return {
      documentsToSign: data.documentsToSign,
      unSavedDocuments: data.unSavedDocuments,
      uploadedDocuments: data.uploadedDocuments,
    };
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});
